export const LOAD_TASK_CATEGORIES = '@TASK_MANAGEMENT/LOAD_TASK_CATEGORIES'
export const LOAD_TASK_USER_LIST = '@TASK_MANAGEMENT/LOAD_TASK_USER_LIST'
export const LOAD_TASK_ASSIGNEE_MYSELF = '@TASK_MANAGEMENT/LOAD_TASK_ASSIGNEE_MYSELF'
export const REGISTER_NEW_TASK = '@TASK_MANAGEMENT/REGISTER_NEW_TASK'
export const LOAD_TASKS = '@TASK_MANAGEMENT/LOAD_TASKS'
export const UPDATE_TASK = '@TASK_MANAGEMENT/UPDATE_TASK'
export const DELETE_TASK = '@TASK_MANAGEMENT/DELETE_TASK'
export const DELETE_SELECTED_TASKS = '@TASK_MANAGEMENT/DELETE_SELECTED_TASKS'
export const UPDATE_TASK_ORDER = '@TASK_MANAGEMENT/UPDATE_TASK_ORDER'
export const UPDATE_SELECTED_TASKS = '@TASK_MANAGEMENT/UPDATE_SELECTED_TASKS'
export const LOAD_MORE_TASKS = '@TASK_MANAGEMENT/LOAD_MORE_TASKS'
export const LOAD_UNREAD_TASKS = '@TASK_MANAGEMENT/LOAD_UNREAD_TASKS'
export const UPDATE_READ_STATUS = '@TASK_MANAGEMENT/UPDATE_READ_STATUS'
export const UPDATE_STATUS_FILTER = '@TASK_MANAGEMENT/UPDATE_STATUS_FILTER'
